var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ke-panel"},[_c('div',{staticClass:"ke-panel-header"},[_vm._t("header"),_vm._v(" "),_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"ke-panel-body"},[_vm._t("description")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }